import { HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, of, switchMap } from 'rxjs';
import { CertificadoService } from '../services/certificado.service';
import { UsuariosService } from '../services/usuarios.service';
import { Usuario } from '@/app/models/interface/usuario.model';

export const certificadosResolver: ResolveFn<Partial<Usuario> | boolean> = (
  route,
  state,
) => {
  const service = inject(CertificadoService);
  const usuarioService = inject(UsuariosService);
  const queryParams = route.queryParams;

  const certificadosId = queryParams['certificadosId'];
  const usuarioId = Number(queryParams['usuarioId']); // Convertir a número

  if (!certificadosId || isNaN(usuarioId)) return of(false); // Evitar errores si faltan datos

  const params = new HttpParams()
    .set('certificadosId', certificadosId)
    .set('withRelations', 'true')
    .set('vigente', 'true');

  return service.findAll(params).pipe(
    map((data) => data.data),
    switchMap((certificados) => {
      const validos = certificados.every(
        (certificado) => certificado.usuario.id_usuario === usuarioId,
      );

      if (!validos) return of(false);

      return usuarioService.findOne(usuarioId).pipe(
        map((usuario) => {
          usuario.certificados = certificados;
          return extractMinimalInfo(usuario);
        }),
      );
    }),
  );
};

const extractMinimalInfo = ({
  id_usuario,
  nombre,
  email,
  apellido,
  avatar,
  certificados,
  correo,
  cuil,
}: Usuario) => ({
  id_usuario,
  nombre,
  email,
  apellido,
  avatar,
  certificados,
  correo,
  cuil,
});
